import { StoreState } from '../store-interfaces';
import { createSelector } from 'reselect';
import { combinedFeatureFlagsSelector } from './featureFlagsSelectors';

export const getGraphLibInstance = (state: StoreState) =>
  state.automation.graphLibInstance;

export const getAutomationAction = (state: StoreState) =>
  state.automation.action;

export const getAutomationActionToOpen = (state: StoreState) =>
  state.automation.actionToOpenOnReady;

export const getAutomationReviewRequiredCount = (state: StoreState) =>
  state.automation.reviewRequiredCount;

export const getAutomationsAggregateStats = (state: StoreState) =>
  state.automation.aggregateStats;

export const getIsAutomationFeatureEnabled = createSelector(
  [combinedFeatureFlagsSelector],
  flags => !!flags.automations,
);

export const getIsAutomationTemplateFeatureEnabled = createSelector(
  [combinedFeatureFlagsSelector],
  flags => !!flags.automations_v1,
);
